import Action from './Action'
// import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from './LoadSimple';
import InputAdmin from './InputAdmin';
import { useFetch } from '../hooks/useFetch';
import SelectorAdmin from './SelectorAdmin';
import { capitalizeFirstLetter } from '../utils/utils';
import { lang } from './generales/traduction';
const ModalCreateTicket =({props,closeTicket})=>{
  const obtenerFechaActualLocal = () => {
      const ahora = new Date();
      const anio = ahora.getFullYear();
      const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
      const dia = String(ahora.getDate()).padStart(2, '0');
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
    
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
  //   const dataAgencies=useFetch('cassia/exception_agencies','','','GET',server)

  const [loadingM,setLoadingM]=useState(false);
  const [IpValid,setIpValid]=useState(true)
  const [matchPassword,setMatchPassword]=useState(false)
  const [disabled,setDisabled]=useState(true)
  const [host,sethost]=useState([])
  const [closeEvent, setCloseEvent] = useState(false);

  const [agenciaId, setAgenciaId] = useState(props.dataAgencies.data.length!=0?props.dataAgencies.data.data[0].exception_agency_id:1);
  const [ManttoData,setManttoData]=useState({
      host_id:props.data.hostid,
      // comment:"",
      event_id:props.data.eventid
         
  })
  const [excepcion, setExcepcion] = useState('');
  const [addingException, setAddingException] = useState(false);

  const [msgError,setMsgError]=useState({status:false,text:''})

  const [validaBtnTicket, setValidaBtnTicket] = useState(true);


  // useEffect(()=>{

  //       if( ManttoData.comment===""  ){
  //           console.log('disabled')
  //           setDisabled(true)
  //       }else{
  //           console.log('no disabled')
  //           setDisabled(false)
  //       }
  // },[ManttoData])


  const addTicket=async(e)=>{
      setAddingException(true)
        // setDataticket({event_id:props.data.eventid,tracker_id:traker,clock:clock})
        ////console.log(dataTicket)
      //   console.log(props.data.hostid,textAreaValue)
        try {
          // const response = await fetch(props.server.url+'/api/v1/cassia/gs/tickets/', {
           const response = await fetch(props.server.url+'/api/v1/cassia/demo-tickets', {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            },
            body: JSON.stringify(ManttoData)
          });
          ////console.log(response)
          if (response.ok) {
            const data = await response.json();
            trigger_ticket()
            setAddingException(false)
            // setClock('')
            //   setValidaBtnTicket(true)
            //   setTextAreaValue('')
            setMsgError({status:false,text:''})
            props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']), capitalizeFirstLetter((lang[props.languaje]['regGenCorr'])), '', true)
            closeTicket()
          } else {
            const data = await response.json();
            props.handleShowPopup('ERROR!!!!', capitalizeFirstLetter((lang[props.languaje]['regNoGenCorr'])), data.detail, false)
            //   setValidaBtnTicket(true)
            setMsgError({status:true,text:data.detail})
            setAddingException(false)
            throw new Error('Error en la solicitud');
          }
        
        } catch (error) {
          // setMsgError({status:true,text:data.detail})
          //  console.log(error)
          
        }
    }
  const trigger_ticket=async(e)=>{
    try {
      const response = await fetch(props.server.url+'/api/v1/cassia/surveys/trigger_ticket_creation', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      //console.log(response)
      if (response.ok) {
        const data = await response.json();
        if(data.data.survey_id!=null){
          props.setImportModalOpen(true);
          props.setSuveryId(data.data.survey_id)
        }
      } else {
        const data = await response.json();
        //console.log(data.detail)
      //   setCloseEvent(false)
      //   setResponseDetail(data.detail)
        throw new Error('Error en la solicitud');
      }
    
    } catch (error) {
      setAddingException(false)
       //console.log(error)
      
    }
  }
  const changeOption=(option,index)=>{
    setManttoData((prevState)=>{
        return {
            ...prevState,
            ['exception_agency_id']:option.value===""?0:(parseInt(option.value))
        }
        
    })
    // setManttoRelation(option.value)
  }
  const [statusTypeTicket,setStatusTypeTicket]=useState(1)
  const [valTypeTicket,setValTypeTicket]=useState('internal_note')
  const changeTypeTicket=(type)=>{
    setStatusTypeTicket(type)
      if(type==1){
        setValTypeTicket('internal_note')
       
      }else{
        setValTypeTicket('progress_solution')
      }
  }
  const handleChange=(e)=>{
    const {name,value}=e.target
    setManttoData((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const handleTextAreaChange = (event) => {
    setManttoData((prevState)=>{
        return {
            ...prevState,
            ['comment']:event.target.value
        }
        
    })
  };
  const [ticketOpen, setTicketOpen] = useState(false);
  const addCommentTicket=async(e)=>{
    setAddingException(true)
      // setDataticket({event_id:props.data.eventid,tracker_id:traker,clock:clock})
      ////console.log(dataTicket)
      // console.log(props.data.hostid,textAreaValue)
      try {
        const response = await fetch(props.server.url+'/api/v1/cassia/gs/tickets/comment/', {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify({ticket_id:props.data.ticket_id,comment:ManttoData.comment,comment_type:valTypeTicket})
        });
        ////console.log(response)
        if (response.ok) {
          
          const data = await response.json();
          ////console.log(data)
          setTicketOpen(false);
          setAddingException(false)
          closeTicket()
          // // setClock('')
          // setTextAreaValue('')
          setValTypeTicket('internal_note')
          
        } else {
          setAddingException(false)
          throw new Error('Error en la solicitud');
        }
      
      } catch (error) {
          
         ////console.log(error)
        
      }
  }
  const {comment,event_id,
      host_id}=ManttoData;
  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                  {
                          // ()
                          (props.data.ticket_id==null || props.data.ticket_id=="")?capitalizeFirstLetter(lang[props.languaje]['crearTicket']):capitalizeFirstLetter(lang[props.languaje]['agregarComentario'])
                         } 
                  </div>
              </div>
              <div className='content-card-modal-gs'>
                              {1==1?
                              // nivelForm===1?
                                  <>
                                  <div className="form-GS-box"> 
                                  {
                          (props.data.ticket_id==null || props.data.ticket_id=="")? 
                          <div className="user-box-GS" style={{height:'25%'}}>
                                      <input required name="name"  type="text" value={host_id} disabled
                                  />
                                      <label className='label-GS'> {(props.data.ticket_id==null || props.data.ticket_id=="")?'Host ID':'Ticket ID'}</label>
                                      
                                      
                                  </div>:
                                  
                          // <InputForm   titulo= text={props.data.} disabled={true} ></InputForm>:
                          <>
                          <div className="user-box-GS" style={{height:'15%'}}>
                          <div style={{width:'50%',height:'100%',display:'flex',justifyContent:'center'}}>
                            <div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:'var(--main-color)',fontSize:'var(--font-size-small)'}}>FOLIO:</div><div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:'var(--green)'}}>&nbsp;&nbsp;{'  '+(props.data.ticket_id==null?'':props.data.ticket_id)}</div>
                            </div>
                            <div style={{width:'50%',height:'100%',display:'flex',justifyContent:'center'}}>
                            <div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:'var(--main-color)',fontSize:'var(--font-size-small)'}}>Status</div><div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:((props.data.ticket_status=='creado')?'var(--green)':((props.data.ticket_status=='error')?'red':'yellow'))}}>&nbsp;&nbsp;{'  '+props.data.ticket_status}</div>
                            </div>
                          </div>
                            {/* <div style={{width:'50%',height:'100%',display:'flex',justifyContent:'center'}}>
                            <div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:'aliceblue',fontWeight:'bold'}}>FOLIO:</div><div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:'lime'}}>&nbsp;&nbsp;{'  '+(props.data.ticket_id==null?'':props.data.ticket_id)}</div>
                            </div>
                            <div style={{width:'50%',height:'100%',display:'flex',justifyContent:'center'}}>
                            <div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:'aliceblue',fontWeight:'bold'}}>Status</div><div style={{display:'flex',justifyContent:'center',alignItems:'center' , color:((props.data.ticket_status=='creado')?'lime':((props.data.ticket_status=='error')?'red':'yellow'))}}>&nbsp;&nbsp;{'  '+props.data.ticket_status}</div>
                            </div> */}
                          </>
}
{
                           (props.data.ticket_id==null || props.data.ticket_id=="")? 
                          <div className="user-box-GS" style={{height:'25%'}}>
                                      <input required name="name"  type="text" value={event_id} disabled
                                  />
                                      <label className='label-GS'> {'Event ID'}</label>
                                      
                                      
                                  </div>:''
                            }
                                  {
                            (props.data.ticket_id==null || props.data.ticket_id=="")?'':(props.data.ticket_status=='creado')?
                            <div className='formColumn' style={{height:'15%',top:'5%',marginBottom: '5%'}}>
                            <div style={{width:'50%',height:'100%',display:'flex',justifyContent:'center'}}>
                            <input type='radio' name='type_ticket' className='type_ticket' defaultChecked={true} onClick={()=>{changeTypeTicket(1)}}></input> <div style={{display:'flex',justifyContent:'center',alignItems:'center' ,  color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>&nbsp; {capitalizeFirstLetter(lang[props.languaje]['notaInterna'])}</div>
                            </div>
                            <div style={{width:'50%',height:'100%',display:'flex',justifyContent:'center'}}>
                            <input type='radio' name='type_ticket' className='type_ticket'  onClick={()=>{changeTypeTicket(2)}} ></input> <div style={{display:'flex',justifyContent:'center',alignItems:'center' ,  color:'var(--txt-color)',fontSize:'var(--font-size-small)'}}>&nbsp; {capitalizeFirstLetter(lang[props.languaje]['notaAvanceSolucion'])}</div>
                            </div>
                       </div>:''
                          }
                                  {(msgError.status)?
                        <div style={{color:'red',position: 'absolute',
                          top: '50%',
                          width: '100%',
                          textAlign: 'center'}}>{msgError.text}</div> :
                        // <div className='menuSearchOption'>
          <div className="user-box-GS" style={{height:'25%'}}>
              {
                (props.data.ticket_status=="creado" || (props.data.ticket_id==null || props.data.ticket_id=="") )?<>
               
                                      {/* <div className='contListIconsAgencys' style={{border:'unset'}}> */}
                                     
                                      {/* <input required name="comment"  type="text" value={comment} onChange={handleTextAreaChange} /> */}
                                      {/* <textarea maxlength="5000" style={{background:'background: var(--white-color)',position:'relative',resize:'none',width:'100%',top:'5%'}} id="nota" name="nota" className="CmtAuth" rows="10" cols="25"  onChange={handleTextAreaChange}></textarea>
                                      <label className='label-GS'>{capitalizeFirstLetter(lang[props.languaje]['notas'])}</label>  */}
                                      {/* <p>0/0</p> */}
                                 
                </>:<div style={{textAlign:'center',color:(props.data.ticket_status=="solicitado")?'var(--txt-color)':'red'}}>{(props.data.ticket_status=="solicitado")?'Se a solicitado un ticket favor de esperar a que sea aceptado':' Se detecto un error al solicitar el ticket  error:'+props.data.ticket_error}</div>
              }
          </div>
      // </div> 
                        }
                                  
                                
                                  
                                  <div className="user-box-admin" style={{height:'25%'}}>
                                      {
                                          (addingException)?<LoadSimple></LoadSimple>
                                          :
                                          <>
                                             {/* <Action origen='Azul' titulo='EJECUTAR' action={addAck} disabled={false}/> */}
                                             {  (props.data.ticket_id==null || props.data.ticket_id=="")? <Action origen='Azul' titulo={capitalizeFirstLetter(lang[props.languaje]['guardar'])} action={addTicket} disabled={false}/>:<Action origen='Azul' titulo={capitalizeFirstLetter(lang[props.languaje]['agregar'])} action={addCommentTicket} disabled={disabled}/>}
                                             <Action origen='Cancelar' titulo={capitalizeFirstLetter(lang[props.languaje]['cancelar'])} action={closeTicket} disabled={false} />
                                          {/* // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/> */}
                                          </>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>{'Usuario '+(editActive? 'editado':'registrado' )+' correctamente'}</span>:''
                                  }
                                      
                                  </div>
                              </div>
                                  </> 
                                  :''
                               
                          }
                          </div>
              </div>
      </div>
  )
}

export default ModalCreateTicket